import React from 'react';
import { defaultTreetStyles } from '../../../shopConfig/config';

interface IconAlertCircleProps {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
}

const IconAlertCircle: React.FC<IconAlertCircleProps> = (props) => {
  const { className, color, height = '16', width = '16' } = props;

  const fillColor = color || defaultTreetStyles.red80;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3455_113)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill={fillColor}
        />
        <rect x="9" y="9" width="2" height="5" transform="rotate(-180 9 9)" fill={fillColor} />
        <rect x="9" y="12" width="2" height="2" transform="rotate(-180 9 12)" fill={fillColor} />
      </g>
      <defs>
        <clipPath id="clip0_3455_113">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconAlertCircle;
